import { render, staticRenderFns } from "./cTemplateBuilderStructureOverrides.vue?vue&type=template&id=11608c06&scoped=true"
import script from "./cTemplateBuilderStructureOverrides.vue?vue&type=script&lang=js"
export * from "./cTemplateBuilderStructureOverrides.vue?vue&type=script&lang=js"
import style0 from "./cTemplateBuilderStructureOverrides.vue?vue&type=style&index=0&id=11608c06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11608c06",
  null
  
)

export default component.exports